import Vue from 'vue'

export default el => new Vue({
  name: 'Highlight Bar',
  el
})
